export default __webpack_public_path__ + "static/media/photography.e790462d.jpg";